import cx from "classnames";
import { SupplierCard_SupplierProductFragment } from "../../../../codegen/graphql";
import { DeliveryDestinations } from "../../../../common/deliveryDestinations";
import { formatCurrency } from "../../../utils/currency";

export default function SupplierCard_VariationBlock({
  variation,
  selectable,
  isVariationSelected,
  handleVariationClick,
  valuesFilter,
  destCountry,
}: {
  variation: SupplierCard_SupplierProductFragment['variations'][number],
  selectable: boolean,
  isVariationSelected: (variation: SupplierCard_SupplierProductFragment['variations'][number]) => boolean,
  handleVariationClick: (variation: SupplierCard_SupplierProductFragment['variations'][number]) => void,
  valuesFilter: string[],
  destCountry: keyof typeof DeliveryDestinations,
}) {
  const calculatedCost = variation.calculatedCost.find((cc) => cc.destinationCountry === destCountry);
  const availableStock = variation.availableStock.find((as) => as.destinationCountry === destCountry);
  const isFiltered = (
    valuesFilter.length > 0
    && !valuesFilter.every(value => variation.typeValues.some(v => (
      v.value[destCountry] === value
    )))
  )
  if (isFiltered) return null

  return (
    <div 
      key={variation.sku}
      className={cx(
        'p-4 rounded-lg border',
        selectable && 'cursor-pointer hover:bg-gray-50',
        isVariationSelected(variation) && 'bg-blue-50 border-blue-200',
        !isVariationSelected(variation) && 'border-gray-200',
      )}
      onClick={selectable ? () => handleVariationClick(variation) : undefined}
    >
      <div className="flex items-start gap-3">
        {selectable && (
          <div className="pt-1">
            <input 
              type="checkbox" 
              checked={isVariationSelected(variation)}
              onChange={() => handleVariationClick(variation)}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded-sm"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium text-gray-900">SKU: {variation.sku}</span>
            <span className="text-sm text-gray-500">({variation.adVariations.length} linked)</span>
          </div>
          
          <div className="flex gap-4 mb-3">
            <img
              src={variation.typeValues.reduce((acc, attr) => {
                if (attr.extraData?.image) {
                  return attr.extraData.image;
                }
                return acc;
              }, '#')}
              alt="Variation"
              className="w-30 h-30 object-cover rounded-lg"
              referrerPolicy="no-referrer"
            />
            <div className="flex-1">
              <div className="text-md font-medium text-gray-900 mb-1">
                {formatCurrency(calculatedCost?.totalCostIncludingVAT ?? -1, calculatedCost?.currency ?? 'EUR')}
              </div>
              <div className="text-sm text-gray-500">
                Stock: {availableStock?.availableStock ?? '-'}
              </div>
              <div className="text-sm font-medium text-blue-600">
                {variation.quantityOrdered || 0} commandés
              </div>
            </div>
          </div>

          <div className="space-y-1">
            {variation.typeValues && variation.typeValues.map((attr, index: number) => (
              <div key={index} className="text-md">
                <span className="font-medium text-gray-700">{attr.type.type[destCountry]}:</span>{' '}
                <span className="text-gray-600">
                  {attr.value[destCountry]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}